import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  VisiteBody,
  VisiteModel,
  VisiteResponse,
} from "../../domaine/visiteModel";
import { addVisiteApi, fetchVisitesByTrancheApi } from "../../api/visite.api";
import { fetchUsersWithProjects } from "./userSlice";

export interface VisiteState {
  loading: "idle" | "pending" | "succeeded" | "failed";
  visitesByTranche: VisiteModel[];
}

const initialState: VisiteState = {
  loading: "idle",
  visitesByTranche: [],
};

export const addVisite: any = createAsyncThunk(
  "visites/addVisite",
  async (newVisite: any, { dispatch }) => {
    const visiteId = await addVisiteApi(newVisite, "visites-generales/");
    await dispatch(fetchUsersWithProjects())
    return visiteId;
  }
);

export const fetchVisitesByTranche: any = createAsyncThunk(
  "visites/fetchVisitesByTranche",
  async (trancheId: number) => {
    const response: VisiteResponse = await fetchVisitesByTrancheApi(trancheId);
    return response.data;
  }
);

export const visitesSlice = createSlice({
  name: "visites",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(addVisite.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(addVisite.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(addVisite.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(fetchVisitesByTranche.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchVisitesByTranche.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.visitesByTranche = action.payload;
      })
      .addCase(fetchVisitesByTranche.rejected, (state) => {
        state.loading = "failed";
        state.visitesByTranche = [];
      });
  },
});

export default visitesSlice.reducer;
